/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerStatusEnum } from './customer-status-enum';

export interface PatchedBatchCustomerStatusRequest {
  ids?: Array<string>;
  customer_status?: CustomerStatusEnum;
  customer_status_explanation?: string | null;
}
export namespace PatchedBatchCustomerStatusRequest {}
